import CodeMessageError from "./CodeMessageError";

export interface IPlainError {
  code?: string;
  message: string;
}

const toPlainError = (error: Error) => {
  if (error instanceof CodeMessageError) {
    return {
      code: error.code,
      message: error.message,
    };
  }
  return {
    message: error.message,
  };
};

export default toPlainError;
